/* eslint-disable react/jsx-key */
/* eslint-disable import/named */
import React from 'react';
import './styles.scss';
import { Avatar, IconButton, MenuItem, Tooltip, Typography } from '@mui/material';
import { useAuth } from 'layout/auth-provider';
import { styled, alpha } from '@mui/material/styles';
import Menu, { MenuProps } from '@mui/material/Menu';
import { useNavigate } from 'react-router-dom';
import { TAB_HOME } from 'constants/AppEnums';
import { Language } from 'shared/Language';
import { SVGIcLogout, SVGUserTags } from 'assets/svg';

const VERSION = 'Version 2.0';

export const Header = (props) => {
    const { locations, onFetchArea, changeCurrentLocations, currentLocation, setTab, tab, orderNo, tabDetail } = props;
    let auth = useAuth();
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    let navigate = useNavigate();
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const userName = localStorage.getItem('Apec_Account');

    const showTableList = (location) => {
        localStorage.setItem('Location', JSON.stringify(location.value));
        changeCurrentLocations(location);
        onFetchArea(location.value);
        handleClose();
    };

    const onChooseTable = () => {
        setTab(TAB_HOME.TABLE);
        navigate('/');
    };

    const onChooseOrderPaid = () => {
        setTab(TAB_HOME.ORDER_PAID);
        navigate('/order-paid');
    };

    const onChoosePayment = () => {
        setTab(TAB_HOME.PAYMENT);
        navigate('/payment');
    };

    return (
        <>
            <div className='d-flex layout-header-01'>
                <div className='d-flex content-left'>
                    <div className="d-flex title-logo" onClick={() => window.location.reload()}>
                        <img src="assets/logo.png" alt="logo" />
                        <div className="table-title">{Language.nameWeb}</div>
                    </div>
                    <div className={`d-flex btn-table-map ${tab === TAB_HOME.TABLE ? 'active' : ''}`} onClick={onChooseTable}>
                        <SVGTableMap color={tab === TAB_HOME.TABLE ? '#B98868' : '#595959'} />
                        <div className='label'>{Language.header.tableMap}</div>
                    </div>
                    {/* <div className={`d-flex btn-order-paid ${tab === TAB_HOME.ORDER_PAID ? 'active' : ''}`} onClick={onChooseOrderPaid}>
                        <SVGOrderPaid color={tab === TAB_HOME.ORDER_PAID ? '#B98868' : '#595959'}/>
                        <div className='label'>{Language.header.orderPaid}</div>
                    </div> */}
                </div>
                <div className='d-flex content-right'>
                    {/* <div className='d-flex btn-payment' onClick={onChoosePayment}>
                        <SVGPayment />
                        <div className='label'>{Language.payment.payment}</div>
                    </div> */}
                    <div className='btn-auth' 
                        style={{
                            backgroundColor: '#FFA731',
                            height: 40,
                            width: 40,
                            borderRadius: 20,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '0px 5px'
                        
                        }}
                    >
                        <Tooltip title={JSON.parse(userName)?.displayName}>
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }} >
                                {/* <Avatar alt={JSON.parse(userName)?.displayName} src="/static/images/avatar/2.jpg" /> */}
                                <span className='text-big bold color-black'>{JSON.parse(userName)?.displayName.slice(0, 2)}</span>
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{ mt: '45px'}}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            <MenuItem  style={{display: 'flex', flexDirection: 'row'}} className='text-user'>
                                <SVGUserTags/>
                                <Typography textAlign="center" >{JSON.parse(userName)?.displayName}</Typography>
                            </MenuItem>
                            <MenuItem onClick={() => { handleCloseUserMenu(); auth.signOut(); }} className='text-red'>
                                <SVGIcLogout/>
                                <Typography textAlign="center">Logout</Typography>
                            </MenuItem>
                            <MenuItem  style={{display: 'flex', flexDirection: 'row'}} className='text-user'>
                                <Typography textAlign="center" >{VERSION}</Typography>
                            </MenuItem>
                        </Menu>
                    </div>
                </div>
            </div>
            {tabDetail ?  <div className='d-flex layout-header-02'>
                <div className='d-flex content-left'>
                    <div className='d-flex logo'>
                        {/* {
                            tab === TAB_HOME.TABLE ? <SVGTableMap1 /> : <SVGOrderPaid color={'#595959'}/>
                        } */}
                        <div onClick={() => { navigate(-1); }} style={{marginRight: 5}}><SVGArrowLeft /></div>

                        <div className='text-big-x color-gray-1 bold mgr-10 mgl-10'>{
                            tab === TAB_HOME.TABLE ? Language.header.tableMap : Language.header.orderPaid
                        } / <span className='text-big-x color-black  bold'>{tabDetail?.nameTab}: <span className='text-big-x color-yellow-5 bold'>{tabDetail?.id}</span>
                        </span></div>
                    </div>
                </div>
                <div className='content-right'>
                    <div className='dropdown-location'>
                        <div className="buttons" onClick={tabDetail?.onPress}>
                            <div className="button-print" >
                                <img src="assets/icon/Print/index.svg" alt="print" className='mgr-10'/>{Language.payment.print}
                            </div>
                        </div>
                    </div>
                </div>
            </div> :  <div className='d-flex layout-header-02'>
                <div className='d-flex content-left'>
                    <div className='d-flex logo'>
                        {
                            tab === TAB_HOME.TABLE ? <SVGTableMap1 /> : <SVGOrderPaid1 />
                        }
                        <div className='label'>{
                            tab === TAB_HOME.TABLE ? Language.header.tableMap : Language.header.orderPaid
                        }</div>
                    </div>
                    {
                        tab === TAB_HOME.TABLE &&   <div className='d-flex description'>
                            <div className='d-flex des-table-empty'>
                                <SVGNoteEmpty />
                                <div className='label'>{Language.header.tableEmpty}</div>
                            </div>
                            <div className='d-flex des-table-customer'>
                                <SVGNoteCustomer />
                                <div className='label'>{Language.header.tableGuests}</div>
                            </div>
                        </div>
                    }
        
                </div>
                <div className='content-right'>
                    <div className='dropdown-location'>
                        <div className='btn-dropdown' onClick={handleClick}>
                            <SVGLocation />
                            <div className='label space-nowrap'>{currentLocation?.text}</div>
                            <SVGArrowBottom />
                        </div>
                        <div className='list-dropdown-item'>
                            <StyledMenu
                                id="demo-customized-menu"
                                MenuListProps={{
                                    'aria-labelledby': 'demo-customized-button'
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                            >
                                {locations?.map((location, index) => (
                                    <MenuItem onClick={() => showTableList(location)}>
                                        {location.text}
                                    </MenuItem>
                                ))}
                            </StyledMenu>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
};

export default Header;

const SVGOrderPaid = ({ color }) => {
    return (
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.59466 8.29953C7.46912 8.2049 7.36754 8.08214 7.29807 7.94112C7.22859 7.80009 7.19318 7.64473 7.19466 7.48753V4.49953C7.19466 4.23432 7.30002 3.97996 7.48755 3.79243C7.67509 3.60489 7.92944 3.49953 8.19466 3.49953C8.45988 3.49953 8.71423 3.60489 8.90176 3.79243C9.0893 3.97996 9.19466 4.23432 9.19466 4.49953V7.02953L10.4947 8.09953C10.7068 8.25867 10.8471 8.49556 10.8846 8.75811C10.9221 9.02066 10.8538 9.28736 10.6947 9.49953C10.5355 9.71171 10.2986 9.85198 10.0361 9.88948C9.77353 9.92699 9.50683 9.85866 9.29466 9.69953L7.59466 8.29953ZM1.43866 5.16653C1.67698 4.28217 2.08719 3.45343 2.64586 2.72763C3.20454 2.00184 3.90072 1.39322 4.69466 0.936534C5.78184 0.309381 7.01765 -0.0139288 8.27268 0.00046015C9.5277 0.0148491 10.7558 0.366407 11.8283 1.01832C12.9008 1.67024 13.7783 2.59852 14.3689 3.70598C14.9596 4.81344 15.2416 6.05932 15.1854 7.31317C15.1293 8.56702 14.737 9.78271 14.0498 10.8329C13.3625 11.8832 12.4055 12.7293 11.279 13.2827C10.1525 13.8362 8.89797 14.0765 7.64668 13.9787C6.39539 13.8808 5.19343 13.4484 4.16666 12.7265C3.94958 12.574 3.80197 12.3415 3.75631 12.0802C3.71064 11.8189 3.77066 11.5501 3.92316 11.333C4.07566 11.116 4.30815 10.9683 4.56948 10.9227C4.83081 10.877 5.09958 10.937 5.31666 11.0895C6.16681 11.6878 7.18231 12.0062 8.22186 12.0005C9.2614 11.9947 10.2733 11.6651 11.1168 11.0574C11.9603 10.4498 12.5934 9.59431 12.928 8.61008C13.2627 7.62586 13.2822 6.56179 12.9839 5.56594C12.6857 4.57008 12.0844 3.69196 11.2638 3.05374C10.4432 2.41551 9.44413 2.04893 8.40549 2.00499C7.36686 1.96106 6.34035 2.24195 5.4688 2.80858C4.59724 3.37522 3.92397 4.19943 3.54266 5.16653H4.69466C5.10666 5.16653 5.34166 5.78253 5.09466 6.11153L3.09466 8.92453C2.89466 9.19153 2.49466 9.14954 2.29466 8.88253L0.294658 6.13253C0.0476585 5.80353 0.282658 5.16653 0.694658 5.16653H1.43766H1.43866Z" fill={color} />
        </svg>
    );
};
const SVGTableMap = ({ color }) => {
    return (
        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.693359 1.5C0.693359 0.672 1.36736 0 2.19336 0H4.19336C5.02136 0 5.69336 0.674 5.69336 1.5V3.5C5.69336 4.328 5.01936 5 4.19336 5H2.19336C1.36536 5 0.693359 4.326 0.693359 3.5V1.5ZM0.693359 8.5C0.693359 7.672 1.36736 7 2.19336 7H4.19336C5.02136 7 5.69336 7.674 5.69336 8.5V10.5C5.69336 11.328 5.01936 12 4.19336 12H2.19336C1.36536 12 0.693359 11.326 0.693359 10.5V8.5ZM7.69336 1.5C7.69336 0.672 8.36736 0 9.19336 0H11.1934C12.0214 0 12.6934 0.674 12.6934 1.5V3.5C12.6934 4.328 12.0194 5 11.1934 5H9.19336C8.36536 5 7.69336 4.326 7.69336 3.5V1.5ZM7.69336 8.5C7.69336 7.672 8.36736 7 9.19336 7H11.1934C12.0214 7 12.6934 7.674 12.6934 8.5V10.5C12.6934 11.328 12.0194 12 11.1934 12H9.19336C8.36536 12 7.69336 11.326 7.69336 10.5V8.5Z" fill={color} />
        </svg>

    );
};
const SVGTableMap1 = () => {
    return (
        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.693359 2.25C0.693359 1.008 1.70436 0 2.94336 0H5.94336C7.18536 0 8.19336 1.011 8.19336 2.25V5.25C8.19336 6.492 7.18236 7.5 5.94336 7.5H2.94336C1.70136 7.5 0.693359 6.489 0.693359 5.25V2.25ZM0.693359 12.75C0.693359 11.508 1.70436 10.5 2.94336 10.5H5.94336C7.18536 10.5 8.19336 11.511 8.19336 12.75V15.75C8.19336 16.992 7.18236 18 5.94336 18H2.94336C1.70136 18 0.693359 16.989 0.693359 15.75V12.75ZM11.1934 2.25C11.1934 1.008 12.2044 0 13.4434 0H16.4434C17.6854 0 18.6934 1.011 18.6934 2.25V5.25C18.6934 6.492 17.6824 7.5 16.4434 7.5H13.4434C12.2014 7.5 11.1934 6.489 11.1934 5.25V2.25ZM11.1934 12.75C11.1934 11.508 12.2044 10.5 13.4434 10.5H16.4434C17.6854 10.5 18.6934 11.511 18.6934 12.75V15.75C18.6934 16.992 17.6824 18 16.4434 18H13.4434C12.2014 18 11.1934 16.989 11.1934 15.75V12.75Z" fill="#0A0B0F" />
        </svg>
    );
};
const SVGPayment = () => {
    return (
        <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M10.0824 1.079C10.269 1.16468 10.4247 1.30573 10.5284 1.483C10.6316 1.63605 10.6888 1.81545 10.6934 2V3C10.6934 3.55 10.2434 4 9.69336 4C9.14336 4 8.74336 3 8.19336 3C8.06039 2.99894 7.93322 2.94538 7.83956 2.85098C7.74591 2.75657 7.69336 2.62898 7.69336 2.496V1.506C7.69336 1.215 7.91936 1.001 8.19836 1.001H9.69336C9.83036 1.001 9.96136 1.03 10.0824 1.08V1.079ZM7.69336 7.707V6.642C7.69336 6.362 7.89736 6.23 8.14936 6.339C8.14936 6.339 10.6934 7.209 10.6934 9.556C10.6934 11.915 8.16236 12.701 8.16236 12.701C7.90936 12.811 7.69336 12.663 7.69336 12.381V11.381C7.69336 11.088 7.87536 10.747 8.10036 10.592C8.10036 10.592 8.69336 10.347 8.69336 9.556C8.69336 8.795 8.10036 8.51 8.10036 8.51C7.88636 8.338 7.69336 7.984 7.69336 7.708V7.707ZM5.69336 0C6.24936 0 6.69336 0.444 6.69336 0.99V13C6.69336 13.547 6.24536 14 5.69336 14C5.13736 14 4.69336 13.552 4.69336 13H1.69336C1.56212 12.9999 1.4322 12.9738 1.31105 12.9234C1.1899 12.8729 1.0799 12.7991 0.98736 12.706C0.894122 12.6136 0.820131 12.5036 0.769667 12.3824C0.719203 12.2613 0.693267 12.1313 0.69336 12V11C0.69336 10.45 1.14336 10 1.69336 10C2.24336 10 2.69336 11 3.69336 11H4.69336V8C4.69336 8 4.26636 7.995 3.69336 7.872C2.50836 7.617 0.69336 6.845 0.69336 4.5C0.69336 2.14 2.50836 1.374 3.69336 1.123C4.26636 1.003 4.69336 1 4.69336 1V0.997C4.69336 0.453 5.14136 0 5.69336 0ZM2.69336 4.5C2.69336 5.26 3.19336 5.635 3.69336 5.82C4.19336 6.005 4.69236 6 4.69336 6V3C4.69236 3 4.19336 2.98 3.69336 3.156C3.19336 3.333 2.69336 3.708 2.69336 4.5Z" fill="white" />
        </svg>

    );
};
const SVGNoteEmpty = () => {
    return (
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.693359" width="20" height="20" rx="10" fill="#19975F" fillOpacity="0.1" />
            <circle cx="10.6934" cy="10" r="6" fill="#19975F" />
        </svg>
    );
};

const SVGNoteCustomer = () => {
    return (
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.693359" width="20" height="20" rx="10" fill="#FFA731" fillOpacity="0.1" />
            <circle cx="10.6934" cy="10" r="6" fill="#FFA731" />
        </svg>
    );
};

const SVGArrowBottom = () => {
    return (
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.39783 0.947881C9.61001 0.742954 9.89419 0.629559 10.1892 0.632123C10.4841 0.634686 10.7663 0.753001 10.9749 0.961585C11.1835 1.17017 11.3018 1.45233 11.3043 1.7473C11.3069 2.04228 11.1935 2.32645 10.9886 2.53863L6.48858 7.03863C6.27761 7.24954 5.99152 7.36801 5.69321 7.36801C5.3949 7.36801 5.1088 7.24954 4.89783 7.03863L0.397832 2.53863C0.192904 2.32645 0.0795106 2.04228 0.0820738 1.7473C0.084637 1.45233 0.202952 1.17017 0.411536 0.961585C0.62012 0.753001 0.902284 0.634686 1.19726 0.632123C1.49223 0.629559 1.7764 0.742954 1.98858 0.947881L5.69321 4.65251L9.39783 0.947881Z" fill="#0A0B0F" />
        </svg>

    );
};

const SVGLocation = () => {
    return (
        <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M6.14673 14.8929C6.09448 14.9641 6.02621 15.0219 5.94745 15.0618C5.86868 15.1017 5.78164 15.1225 5.69336 15.1225C5.60508 15.1225 5.51803 15.1017 5.43927 15.0618C5.36051 15.0219 5.29224 14.9641 5.23998 14.8929C2.16761 10.7136 0.630859 7.72894 0.630859 5.94019C0.630859 3.12769 2.88086 0.877686 5.69336 0.877686C8.50586 0.877686 10.7559 3.12769 10.7559 5.94019C10.7559 7.72894 9.21911 10.7136 6.14673 14.8929ZM5.69336 8.19019C6.2901 8.19019 6.86239 7.95313 7.28435 7.53118C7.70631 7.10922 7.94336 6.53692 7.94336 5.94019C7.94336 5.34345 7.70631 4.77115 7.28435 4.3492C6.86239 3.92724 6.2901 3.69019 5.69336 3.69019C5.09662 3.69019 4.52433 3.92724 4.10237 4.3492C3.68041 4.77115 3.44336 5.34345 3.44336 5.94019C3.44336 6.53692 3.68041 7.10922 4.10237 7.53118C4.52433 7.95313 5.09662 8.19019 5.69336 8.19019Z" fill="#333333" />
        </svg>
    );
};
const SVGOrderPaid1 = () => {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M10.4134 3L10.3459 3.141C9.98586 3.8925 10.3714 4.5 11.2069 4.5H14.1799C15.0289 4.5 15.3904 3.9075 15.0169 3.1755L14.9269 3H17.1934V4.5C17.1934 4.89524 17.0374 5.27451 16.7593 5.55539C16.4813 5.83627 16.1036 5.99605 15.7084 6H9.67836C9.48225 5.99941 9.28818 5.9601 9.1073 5.88433C8.92642 5.80855 8.76228 5.6978 8.62431 5.55844C8.48633 5.41907 8.37724 5.25383 8.30329 5.07219C8.22933 4.89056 8.19198 4.69611 8.19336 4.5V3H10.4134L10.4809 2.859C10.8409 2.109 11.8054 1.5 12.6469 1.5C13.4839 1.5 14.4709 2.1075 14.8369 2.8245L14.9284 3H19.4509C19.7451 2.99901 20.0367 3.05614 20.3088 3.16811C20.5809 3.28009 20.8283 3.44469 21.0366 3.65249C21.245 3.86028 21.4102 4.10718 21.5229 4.37901C21.6356 4.65083 21.6936 4.94224 21.6934 5.2365V20.265C21.6894 20.8581 21.4514 21.4256 21.0312 21.8442C20.611 22.2627 20.0425 22.4984 19.4494 22.5H5.93736C5.64297 22.5012 5.35125 22.4442 5.07895 22.3323C4.80665 22.2204 4.55914 22.0559 4.35062 21.848C4.14211 21.6402 3.97671 21.3933 3.86391 21.1213C3.75112 20.8494 3.69316 20.5579 3.69336 20.2635V5.235C3.69731 4.6419 3.93529 4.07436 4.35552 3.65581C4.77575 3.23726 5.34425 3.00157 5.93736 3H10.4134ZM18.6934 18V17.2425C18.6936 17.1443 18.6743 17.047 18.6365 16.9564C18.5988 16.8657 18.5435 16.7834 18.4737 16.7144C18.4039 16.6453 18.3211 16.5907 18.23 16.5539C18.139 16.5171 18.0415 16.4988 17.9434 16.5C17.5414 16.5 17.1934 16.833 17.1934 17.2425V18H16.4359C16.3377 17.9998 16.2404 18.0191 16.1497 18.0568C16.0591 18.0945 15.9768 18.1499 15.9077 18.2197C15.8386 18.2895 15.7841 18.3723 15.7473 18.4633C15.7105 18.5544 15.6922 18.6518 15.6934 18.75C15.6934 19.152 16.0264 19.5 16.4359 19.5H17.1934V20.2575C17.1934 20.6775 17.5294 21 17.9434 21C18.3454 21 18.6934 20.667 18.6934 20.2575V19.5H19.4509C19.8709 19.5 20.1934 19.164 20.1934 18.75C20.1934 18.348 19.8604 18 19.4509 18H18.6934ZM6.69336 9.75C6.69336 10.152 7.02336 10.5 7.42986 10.5H14.9569C15.1558 10.5 15.3465 10.421 15.4872 10.2803C15.6278 10.1397 15.7069 9.94891 15.7069 9.75C15.7069 9.55109 15.6278 9.36032 15.4872 9.21967C15.3465 9.07902 15.1558 9 14.9569 9H7.42986C7.2333 9.00354 7.04598 9.08412 6.90824 9.22439C6.77049 9.36466 6.69333 9.5534 6.69336 9.75ZM6.69336 12.75C6.69336 13.152 7.02936 13.5 7.44336 13.5H17.9434C18.3484 13.5 18.6934 13.164 18.6934 12.75C18.6934 12.348 18.3574 12 17.9434 12H7.44336C7.03836 12 6.69336 12.336 6.69336 12.75ZM6.69336 15.75C6.69336 16.152 7.02336 16.5 7.42986 16.5H14.9569C15.1558 16.5 15.3465 16.421 15.4872 16.2803C15.6278 16.1397 15.7069 15.9489 15.7069 15.75C15.7069 15.5511 15.6278 15.3603 15.4872 15.2197C15.3465 15.079 15.1558 15 14.9569 15H7.42986C7.2333 15.0035 7.04598 15.0841 6.90824 15.2244C6.77049 15.3647 6.69333 15.5534 6.69336 15.75ZM6.69336 18.75C6.69336 19.152 7.02636 19.5 7.43586 19.5H10.4509C10.8709 19.5 11.1934 19.164 11.1934 18.75C11.1934 18.348 10.8604 18 10.4509 18H7.43586C7.33766 17.9998 7.2404 18.0191 7.14973 18.0568C7.05907 18.0945 6.9768 18.1499 6.90771 18.2197C6.83863 18.2895 6.7841 18.3723 6.7473 18.4633C6.7105 18.5544 6.69217 18.6518 6.69336 18.75Z" fill="#0A0B0F" />
        </svg>


    );
};

const SVGArrowLeft = () => {
    return (
        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.27735 13.9415C9.55419 14.237 9.70528 14.6286 9.69868 15.0334C9.69207 15.4383 9.5283 15.8247 9.24197 16.1111C8.95564 16.3974 8.5692 16.5612 8.16432 16.5678C7.75944 16.5744 7.36787 16.4233 7.07235 16.1465L0.757352 9.82996C0.465154 9.53745 0.301025 9.14091 0.301025 8.72746C0.301025 8.31401 0.465154 7.91747 0.757352 7.62496L7.07235 1.30996C7.36787 1.03312 7.75944 0.882033 8.16432 0.888635C8.5692 0.895238 8.95564 1.05901 9.24197 1.34534C9.5283 1.63167 9.69207 2.01811 9.69868 2.42299C9.70528 2.82787 9.55419 3.21945 9.27735 3.51496L4.06485 8.72746L9.27735 13.9415Z" fill="#333333" />
        </svg>

    );
};
const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 294,
        color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0'
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5)
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                )
            }
        }
    }
}));
